import Button from "components/ui/Button";
import InputDatePicker from "components/ui/forms/InputDatePicker";
import InputField from "components/ui/forms/InputField";
import InputSelect from "components/ui/forms/InputSelect";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

const TransactionHistoryFilters = ({ setSelectedFilters, handleFilters }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
  });

  const onSubmit = async (data) => {
    setIsLoading(true);
    //console.log(data);
    handleFilters(data);
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };

  const CATEGORY_OPTIONS = [
    { value: "mainCategory", label: "Main Category" },
    { value: "casino", label: "Casino" },
  ];
  const TRANSACTION_TYPE_OPTIONS = [
    { value: "all", label: "All" },
    { value: "withdrawalRequest", label: "Withdrawal request" },
    { value: "withdrawalRequestPayment", label: "Withdrawal request Payment" },
    { value: "deposit", label: "Deposit" },
    { value: "depositRequestPayment", label: "Deposit request payment" },
    {
      value: "rejectedWithdrawalRequest",
      label: "Rejected withdrawal request",
    },
    { value: "bets", label: "Bets" },
    { value: "increasingTheWinning", label: "Increasing the winning" },
    { value: "decreasingTheWinning", label: "Decreasing the winning" },
    { value: "loyaltyPointExchange", label: "Loyalty Point Exchange" },
    { value: "casino", label: "Casino" },
    { value: "casinoBetWinning", label: "Casino Bet Winning" },
    { value: "casinoCashBackBonus", label: "Casino CashBack Bonus" },
    { value: "betCashout", label: "bet cashout" },
    { value: "correctionDown", label: "Correction up" },
    { value: "correctionDown", label: "Correction down" },
    { value: "cashBackCorrection", label: "CashBack Correction" },
  ];

  useEffect(() => {
    setValue("category", CATEGORY_OPTIONS[0]);
    setValue("transactionType", TRANSACTION_TYPE_OPTIONS[0]);
    setSelectedFilters(getValues());
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      <div className="md:flex gap-2 md:space-y-0 space-y-1">
        <InputSelect
          label="Transaction Type"
          name="transactionType"
          options={TRANSACTION_TYPE_OPTIONS}
          control={control}
          {...register("transactionType")}
        />
        <InputSelect
          label="Category"
          name="category"
          options={CATEGORY_OPTIONS}
          control={control}
          {...register("category")}
        />
        <InputDatePicker
          selectsStart
          label="Range"
          placeholderText="From"
          name="fromDate"
          control={control}
          {...register("fromDate")}
          selected={watch("fromDate")}
          startDate={watch("fromDate")}
          endDate={watch("toDate")}
          maxDate={watch("toDate") ? watch("toDate") : new Date()}
          onChange={(date) => {
            setValue("fromDate", date);
          }}
        />
        <InputDatePicker
          selectsEnd
          placeholderText="To"
          name="toDate"
          control={control}
          selected={watch("toDate")}
          startDate={watch("fromDate")}
          endDate={watch("toDate")}
          minDate={watch("fromDate")}
          maxDate={new Date()}
          {...register("toDate")}
          onChange={(date) => {
            setValue("toDate", date);
          }}
        />
      </div>
      <div className="pt-5">
        <Button
          label={isLoading ? "Logging in..." : "Show"}
          type="submit"
          size="small"
          variant="green"
          className="uppercase md:max-w-[250px] w-full ml-auto"
        />
      </div>
    </form>
  );
};

export default TransactionHistoryFilters;
